import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import OurLogo from '../c/OurLogo';
import ChangeArrow from '../c/ChangeArrow';
import XTab from '../c/XTab';
import { T } from '../traks';
import I18N from '../I18N';

import { Apify } from '../Apify';

const DefaultLeaderboard = Apify("/z/leaderboard")
	.with_query_from_props(props => ({key: props.data_key, type: "default"}))
	.with_refresh_interval(5*60) // refresh every 5 minutes
	.with_response_prop("data")
	.wrap((props) => {
        const { data } = props;
        const [tabIndex, setTabIndex] = React.useState(0)
        const [rows, setRows] = React.useState(data.Portfolios.length !== 0 ? data.Portfolios.map((p) => p) : []);

        const tabs = [<span><T>Value</T></span>, <span><T>Risk score</T></span>]
        
        useEffect(() => {
            let newRows;
            if (tabIndex === 0) {
                newRows = data.Portfolios.map((p) => p);
            } else if (tabIndex === 1) {
                newRows = data.BetaPortfolios.map((p) => p);
            }

            setRows(newRows);
        }, [tabIndex])

        const on_select = (i) => {
            setTabIndex(i);
        };


        let leaderboardClasses = 'leaderboard_ranking p-md-0 container'

        if (data.CanUseBetaValues) {
            leaderboardClasses += ' leaderboard_tabs'
        }

        const getRows = () => {
            return rows.map((p) => {
                const key = p.Id;
                const percent_delta = ((p.Value - data.GameInitialAmount) / data.GameInitialAmount) * 100;
                const game_currency = data.GameCurrency;
                let place_icon = null;
                switch(p.Place) {
                    default:
                        place_icon = <span>{p.Place}.</span>;
                }

                return (<tr key={key}>
                        <td></td>
                        <td className="ad_th_1px fw-bold">{place_icon}</td>
                        <td className="fw-bold">{p.OwnerScreenName}</td>
                        <td className="text-right fw-bold">{p.TradesCount}</td>
                        <td className="text-right fw-bold">{I18N.floatval_unit(p.Value, 2, game_currency)}</td>
                        <td className="text-right fw-bold"><ChangeArrow pct={percent_delta} suffix="%"/></td>
                        {data.CanUseBetaValues && tabIndex === 1 && (
                            <td className="text-right fw-bold">
                                {
                                    p.BetaValue !== 0 ?
                                        I18N.floatval_unit(p.BetaValue, 4) : I18N.floatval_unit(0, 4)
                                }
                            </td>
                        )}
                        {data.CanUseBetaValues && tabIndex === 1 && (
                            <td className="text-right">
                                {
                                    p.BetaValue !== 0 ?
                                        I18N.floatval_unit(percent_delta / p.BetaValue, 4) : I18N.floatval_unit(0, 4)
                                } %
                            </td>
                        )}
                    </tr>
                );
            });
        }
		return (
			<React.Fragment>
			<Container fluid className="bg-color-black">
				<Container fluid className="p-2 flex-column flex-nowrap flex-md-row justify-content-md-end lign-items-baseline h-100 container">
					<Row className="flex-nowrap">
						<Col lg="6">
							<OurLogo className="leaderboard_logo" />
						</Col>
						<Col lg="6" className="d-flex flex-column justify-content-center text-right">
							<div className="pb-1 txt-color-white fw-bold"><T>Leaderboard</T></div>
							<div className="leaderboard_game_name">{data.GameName}</div>
						</Col>
					</Row>
                    {data.CanUseBetaValues && (
                    <Row>
                        <Col>
                            <XTab row_classes={["pb-4", "no_unselected_border"]} add_classes={["white"]} selected={tabIndex} onSelect={on_select} tabs={tabs}/>
                        </Col>
                    </Row>
                    )}
				</Container>
			</Container>
            
				<Container fluid className={leaderboardClasses}>                 
					<Row className="pb-2">
						<Col className="py-5">
							<table className="ad_leader_board w-100 bg-color-white">
								<thead className="text-capitalize">
									<tr>
										<th></th>
										<th></th>
										<th className="ad_game_table_header font-s"><T>NAME</T></th>
										<th className="ad_game_table_header font-s text-right"><T>TRADES</T></th>
										<th className="ad_game_table_header font-s text-right"><T>VALUE</T></th>
										<th className="ad_game_table_header font-s text-right"><T>TOTAL CHANGE</T></th>
                                        {data.CanUseBetaValues && tabIndex === 1 && (
                                            <th className="ad_game_table_header font-s text-right"><T>The risk score of the portfolio (Beta)</T></th>
                                        )}
                                        {data.CanUseBetaValues && tabIndex === 1 && (
                                            <th className="ad_game_table_header font-s text-right"><T>The risk-adjusted return of the portfolio</T></th>
                                        )}
									</tr>
								</thead>
								<tbody>
									{getRows()}
								</tbody>
							</table>
						</Col>
					</Row>
				</Container>
			</React.Fragment>
		);
	});

export {
	DefaultLeaderboard,
};



// WEBPACK FOOTER //
// ./src/p/Leaderboard.js